@if (name) {
  <mat-icon
    [svgIcon]="name"
    [ngStyle]="{ height: height || size, width: width || size }"
    [ngClass]="classColor"
  ></mat-icon>
}
